import {
    Check,
    Minus,
} from "lucide-preact";
import type {
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

type CheckboxProps = Omit<JSX.InputHTMLAttributes<HTMLInputElement>, "type"> & {
    label?: string;
    indeterminate?: boolean;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({
        label,
        indeterminate,
        className = "",
        disabled,
        checked,
        ...props
    }, ref) => {
        return (
            <label
                className={`inline-flex items-center gap-2 cursor-pointer ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${className}`}
            >
                <div className="relative">
                    <input
                        ref={ref}
                        type="checkbox"
                        className="sr-only peer"
                        disabled={disabled}
                        checked={checked}
                        {...props}
                    />
                    <div
                        className={`
                        w-5 h-5 rounded border-2 transition-colors duration-200
                        bg-bg-secondary border-border
                        peer-checked:bg-accent peer-checked:border-accent
                        peer-focus-visible:ring-2 peer-focus-visible:ring-accent peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-bg-primary
                        ${indeterminate ? "bg-accent border-accent" : ""}
                    `.trim().replace(/\s+/g, " ")}
                    >
                        {(checked || indeterminate) && (
                            <div className="absolute inset-0 flex items-center justify-center text-white">
                                {indeterminate
                                    ? <Minus size={14} strokeWidth={3} />
                                    : <Check size={14} strokeWidth={3} />}
                            </div>
                        )}
                    </div>
                </div>
                {label && (
                    <span className="text-text-primary select-none">
                        {label}
                    </span>
                )}
            </label>
        );
    },
);
